(function () {
  'use strict';
  if (window.__RKDynamicGalleryV4) return;
  window.__RKDynamicGalleryV4 = true;

  var ROOT='[data-section-type="product"][data-product-handle]';
  var SLIDE='[data-product-slideshow] [data-media-slide]';
  var THUMB='[data-product-thumbs] [data-slideshow-thumbnail]';
  var cache=new Map();
  var timers=new WeakMap();

  function id(v){var m=String(v==null?'':v).match(/(\d+)$/);return m?m[1]:String(v||'');}
  function norm(v){return String(v||'').trim().toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'');}
  function handle(root){return root.getAttribute('data-product-handle')||'';}
  function cleanBadge(scope){(scope||document).querySelectorAll('.product__media__wrapper > .product-tag').forEach(function(x){if(!String(x.textContent||'').trim())x.remove();});}

  function product(root){
    var h=handle(root);if(!h)return Promise.resolve(null);
    if(cache.has(h))return cache.get(h);
    var base=window.Shopify&&Shopify.routes&&Shopify.routes.root?Shopify.routes.root:'/';
    var p=fetch(base+'products/'+h+'.js',{credentials:'same-origin',headers:{Accept:'application/json'}})
      .then(function(r){if(!r.ok)throw new Error('Product JSON '+r.status);return r.json();})
      .catch(function(e){cache.delete(h);console.warn('[RK Gallery]',h,e);return null;});
    cache.set(h,p);return p;
  }

  function optionNames(p){return (p.options||[]).map(function(o){return typeof o==='string'?o:(o&&o.name?o.name:'');});}

  function liveSelections(root,p){
    var names=optionNames(p), found={};
    root.querySelectorAll('[name^="options["]').forEach(function(control){
      var name=String(control.getAttribute('name')||'').match(/^options\[(.+)\]$/);
      if(!name)return;
      var type=String(control.type||'').toLowerCase();
      if((type==='radio'||type==='checkbox')&&!control.checked)return;
      if(control.value!=null&&String(control.value)!=='')found[norm(name[1])]=String(control.value);
    });
    return names.map(function(name){return found[norm(name)]||'';});
  }

  function variantFromSelections(root,p){
    var values=liveSelections(root,p);
    if(!values.length||!values.some(Boolean))return null;
    return (p.variants||[]).find(function(v){
      return values.every(function(value,i){return !value||String((v.options||[])[i])===String(value);});
    })||null;
  }

  function selectedVariant(root,p,eventVariant){
    if(eventVariant&&eventVariant.id){
      var ev=(p.variants||[]).find(function(v){return id(v.id)===id(eventVariant.id);});
      if(ev)return ev;
    }
    var live=variantFromSelections(root,p);if(live)return live;
    var input=root.querySelector('form [name="id"]');
    if(input&&input.value){var fv=(p.variants||[]).find(function(v){return id(v.id)===id(input.value);});if(fv)return fv;}
    try{var q=new URL(location.href).searchParams.get('variant');if(q){var uv=(p.variants||[]).find(function(v){return id(v.id)===id(q);});if(uv)return uv;}}catch(e){}
    return (p.variants||[]).find(function(v){return v.available;})||(p.variants||[])[0]||null;
  }

  function variantMediaIds(v){
    if(!v)return [];
    var out=[];
    if(v.featured_media&&v.featured_media.id)out.push(id(v.featured_media.id));
    if(v.featured_image&&typeof v.featured_image==='object'&&v.featured_image.id)out.push(id(v.featured_image.id));
    if(Array.isArray(v.media))v.media.forEach(function(m){if(m&&m.id)out.push(id(m.id));});
    return Array.from(new Set(out.filter(Boolean)));
  }

  function mediaOwners(p){
    var owners=new Map();
    (p.variants||[]).forEach(function(v){variantMediaIds(v).forEach(function(mid){if(!owners.has(mid))owners.set(mid,new Set());owners.get(mid).add(id(v.id));});});
    return owners;
  }

  function selectedValues(v){return v&&Array.isArray(v.options)?v.options.map(norm):[];}
  function allOptionValues(p){
    var sets=[];
    (p.variants||[]).forEach(function(v){(v.options||[]).forEach(function(val,i){if(!sets[i])sets[i]=new Set();sets[i].add(String(val));});});
    return sets.map(function(s){return Array.from(s).sort(function(a,b){return norm(b).length-norm(a).length;});});
  }

  function mediaElement(root,mid){return root.querySelector(THUMB+'[data-media-select="'+mid+'"]')||root.querySelector(SLIDE+'[data-media-id="'+mid+'"]');}
  function descriptor(root,mid){
    var el=mediaElement(root,mid);if(!el)return '';
    var img=el.querySelector('img');
    var parts=[];
    if(img){
      if(img.alt)parts.push(img.alt);
      var src=img.currentSrc||img.getAttribute('src')||img.getAttribute('data-src')||'';
      if(src){try{parts.push(decodeURIComponent(src.split('/').pop().split('?')[0]));}catch(e){parts.push(src.split('/').pop().split('?')[0]);}}
    }
    var filter=(el.getAttribute('data-image-filter')||'').trim();if(filter)parts.push(filter);
    return norm(parts.join(' '));
  }

  function optionScope(root,mid,v,p){
    var text=descriptor(root,mid);if(!text)return null;
    var selected=selectedValues(v), universe=allOptionValues(p), matched=false;
    var padded='-'+text+'-';
    for(var i=0;i<universe.length;i++){
      var found='';
      for(var j=0;j<universe[i].length;j++){
        var n=norm(universe[i][j]);
        if(n&&padded.indexOf('-'+n+'-')!==-1){found=n;break;}
      }
      if(found){matched=true;if(selected[i]!==found)return false;}
    }
    return matched?true:null;
  }

  function groupForSelected(root,v){
    var mids=variantMediaIds(v),group='';
    mids.some(function(mid){var el=mediaElement(root,mid);group=el?(el.getAttribute('data-image-filter')||'').trim():'';return !!group;});
    if(group)return group;
    var vals=(v.options||[]).map(norm),candidates=['variant_'+vals.join('-'),'variant-'+vals.join('-'),vals.join('-'),'variant_'+vals.join('_'),vals.join('_')];
    var existing=new Set();root.querySelectorAll(SLIDE+', '+THUMB).forEach(function(el){var g=(el.getAttribute('data-image-filter')||'').trim();if(g)existing.add(g);});
    return candidates.find(function(c){return existing.has(c);})||'';
  }

  function visible(el,yes){el.hidden=!yes;el.style.display=yes?'':'none';el.setAttribute('aria-hidden',yes?'false':'true');el.setAttribute('data-rk-variant-hidden',yes?'false':'true');}
  function flickity(el){if(!el)return null;try{if(window.Flickity&&Flickity.data)return Flickity.data(el);}catch(e){}try{if(window.jQuery)return jQuery(el).data('flickity')||null;}catch(e){}return null;}

  function selectFirst(root,preferred){
    var show=Array.from(root.querySelectorAll(SLIDE)).filter(function(x){return x.getAttribute('data-rk-variant-hidden')!=='true';});if(!show.length)return;
    var target=null;preferred.some(function(mid){target=show.find(function(x){return id(x.getAttribute('data-media-id'))===mid;});return !!target;});
    if(!target)target=show[0];var targetId=id(target.getAttribute('data-media-id'));
    root.querySelectorAll(SLIDE).forEach(function(x){x.classList.toggle('is-selected',x===target);});
    root.querySelectorAll(THUMB).forEach(function(x){x.classList.toggle('is-activated',id(x.getAttribute('data-media-select'))===targetId);});
    var stage=root.querySelector('[data-product-slideshow]'),f=flickity(stage);
    if(f){try{f.reloadCells();f.resize();var cell=f.getCell?f.getCell(target):null;var idx=cell&&f.cells?f.cells.indexOf(cell):show.indexOf(target);f.select(Math.max(idx,0),false,true);}catch(e){console.warn('[RK Gallery] Flickity',e);}}
    else window.dispatchEvent(new Event('resize'));
  }

  function apply(root,p,eventVariant){
    cleanBadge(root);if(!p||!Array.isArray(p.variants))return;
    var v=selectedVariant(root,p,eventVariant);if(!v)return;
    var vid=id(v.id),preferred=variantMediaIds(v),owners=mediaOwners(p),group=groupForSelected(root,v),count=0;

    function shouldShow(el,mid){
      var owned=owners.get(mid),scoped=optionScope(root,mid,v,p);
      /* Ownership blocks sibling media. Descriptor/filter can further refine shared ownership (letters/colors). */
      if(owned&&owned.size){if(!owned.has(vid))return false;if(scoped===false)return false;return true;}
      var g=(el.getAttribute('data-image-filter')||'').trim();
      if(g&&group)return g===group;
      return scoped===null?true:scoped;
    }

    root.querySelectorAll(SLIDE).forEach(function(el){var yes=shouldShow(el,id(el.getAttribute('data-media-id')));visible(el,yes);if(yes)count++;});
    root.querySelectorAll(THUMB).forEach(function(el){visible(el,shouldShow(el,id(el.getAttribute('data-media-select'))));});

    if(!count){
      root.querySelectorAll(SLIDE).forEach(function(el){var mid=id(el.getAttribute('data-media-id')),scoped=optionScope(root,mid,v,p);if(!owners.has(mid)&&scoped!==false){visible(el,true);count++;}});
      root.querySelectorAll(THUMB).forEach(function(el){var mid=id(el.getAttribute('data-media-select')),scoped=optionScope(root,mid,v,p);if(!owners.has(mid)&&scoped!==false)visible(el,true);});
    }
    selectFirst(root,preferred);
    root.setAttribute('data-rk-gallery-active','true');
    root.setAttribute('data-rk-selected-variant',vid);
    root.setAttribute('data-rk-selected-media',preferred[0]||'');
    root.setAttribute('data-rk-selected-group',group);
    root.setAttribute('data-rk-visible-media-count',String(count));
  }

  function refresh(root,eventVariant){if(!root||!document.documentElement.contains(root))return;product(root).then(function(p){apply(root,p,eventVariant);});}
  function schedule(root,eventVariant,delay){if(!root)return;var old=timers.get(root);if(old)clearTimeout(old);timers.set(root,setTimeout(function(){timers.delete(root);requestAnimationFrame(function(){refresh(root,eventVariant||null);});},delay||0));}
  function burst(root,eventVariant){schedule(root,eventVariant,0);setTimeout(function(){schedule(root,null,0);},60);setTimeout(function(){schedule(root,null,0);},180);}
  function all(){cleanBadge(document);document.querySelectorAll(ROOT).forEach(function(r){burst(r,null);});}

  document.addEventListener('theme:variant:change',function(e){var r=e.target&&e.target.closest?e.target.closest(ROOT):null,v=e.detail&&e.detail.variant?e.detail.variant:null;if(r)burst(r,v);else all();});
  document.addEventListener('change',function(e){var r=e.target&&e.target.closest?e.target.closest(ROOT):null;if(r)burst(r,null);});
  document.addEventListener('input',function(e){var r=e.target&&e.target.closest?e.target.closest(ROOT):null;if(r&&String(e.target.getAttribute('name')||'').indexOf('options[')===0)burst(r,null);});
  document.addEventListener('click',function(e){var trigger=e.target&&e.target.closest?e.target.closest('[data-popout-option], [data-swatch-input] + label, .radio__button label, radio-swatch label, [name^="options["] + label'):null;if(!trigger)return;var r=trigger.closest(ROOT);if(r)burst(r,null);});
  document.addEventListener('shopify:section:load',all);
  window.addEventListener('popstate',function(){setTimeout(all,0);});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all,{once:true});else all();
})();
